export enum RentalsRoutePathsEnum {
  RENTAL = 'rentals/:rentalId',
  RENTALS = 'rentals',
}
